import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { FormattedMessage, useIntl } from 'dibs-react-intl';
import { defaultLocale } from 'dibs-intl/exports/constants';

import { PdpSharedBuyerProtectionGuarantee } from './PdpSharedBuyerProtectionGuarantee';
import { PdpSharedBuyerProtectionAuctions } from './PdpSharedBuyerProtectionAuctions';

import styles from './PdpSharedBuyerProtection.scss';

export const PdpSharedBuyerProtectionBoxComponent = ({ viewer, user, item }) => {
    const { locale } = useIntl();
    const { isAuctionEnabled } = item || {};
    const { isIntlFeaturesEnabled } = viewer || {};

    return (
        <div className={styles.wrapper} data-tn="buyer-protection-wrrapper">
            {isAuctionEnabled && <PdpSharedBuyerProtectionAuctions />}
            <PdpSharedBuyerProtectionGuarantee user={user} />
            {isIntlFeaturesEnabled && locale !== defaultLocale && (
                <div className={styles.copy}>
                    <div className={styles.message}>
                        <FormattedMessage
                            id="PdpSharedBuyerProtectionBox.translation.message"
                            defaultMessage="Parts of this page have been automatically translated. 1stDibs cannot guarantee the accuracy of translations. English is the default language of this website."
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

PdpSharedBuyerProtectionBoxComponent.propTypes = {
    viewer: PropTypes.object,
    user: PropTypes.object,
    item: PropTypes.object,
};

export const PdpSharedBuyerProtectionBox = createFragmentContainer(
    PdpSharedBuyerProtectionBoxComponent,
    {
        viewer: graphql`
            fragment PdpSharedBuyerProtectionBox_viewer on Viewer {
                isIntlFeaturesEnabled: featureFlag(feature: "intlMVP2022")
            }
        `,
        item: graphql`
            fragment PdpSharedBuyerProtectionBox_item on Item {
                isAuctionEnabled
            }
        `,
        user: graphql`
            fragment PdpSharedBuyerProtectionBox_user on User {
                ...PdpSharedBuyerProtectionGuarantee_user
            }
        `,
    }
);
